import axios from "axios";
import API from "../api";

export async function get(mainToken, assuranceType, guid) {
  const params = {
    guid
  };
  return new Promise(resolve => {
    const url = API.userBaloonPro[assuranceType];
    const request = axios.get(url, {
      params,
      headers: {
        Authorization: `bearer ${mainToken}`
      }
    });
    return request
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        resolve({ error: true, res: err });
      });
  });
}
